import Flickity from 'Flickity'

function DOMready(callback) {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

DOMready(function () {
  const navItemsArray = document.querySelectorAll('.product-details__nav-item')
  const optionsFlkty = {
    cellAlign: 'left',
    prevNextButtons: true,
    contain: true,
    pageDots: false,
    percentPosition: false,
  }

  if (navItemsArray.length > 0) {
    navItemsArray.forEach((navItem) => {
      const carouselArray = document.querySelectorAll(
        '.product-details__inner .before-after__carousel'
      )

      if (navItem.classList.contains('active')) {
        const dataIndex = navItem.dataset.index
        const activeTab = document.querySelector(dataIndex)
        if (activeTab) {
          activeTab.style.display = 'block'

          if (carouselArray.length > 0) {
            carouselArray.forEach((carousel) => {
              setTimeout(() => {
                new Flickity(carousel, optionsFlkty).resize()
              }, 350)
            })
          }
        }
      }

      navItem.addEventListener('click', function (e) {
        e.preventDefault()
        const dataIndex = this.dataset.index
        const activeTab = document.querySelector(dataIndex)
        if (!activeTab) return

        const siblingsArray = Array.prototype.filter.call(
          navItem.parentNode.children,
          (child) => child !== navItem
        )
        const tabsArray = document.querySelectorAll('.product-details__content')

        this.classList.add('active')

        siblingsArray.forEach((item) => {
          item.classList.remove('active')
        })
        tabsArray.forEach((tab) => {
          tab.style.display = ''
        })

        activeTab.style.display = 'block'

        if (carouselArray.length > 0) {
          carouselArray.forEach((carousel) => {
            if (carousel.classList.contains('flickity-enabled'))
              new Flickity(carousel, optionsFlkty).destroy()
            else new Flickity(carousel, optionsFlkty).resize()
          })
        }
      })
    })
  }

  // Handler for full ingredient list
  const fullIngredientTitle = document.querySelector(
    '.product-details__full-list-title'
  )

  if (fullIngredientTitle) {
    fullIngredientTitle.addEventListener('click', (event) => {
      event.target.classList.toggle('active')

      const acc = document.querySelectorAll('.js-accordion')
      if (acc.length > 0) {
        acc.forEach((el) => {
          if (el.classList.contains('js-active')) {
            setTimeout(() => {
              el.nextElementSibling.style.maxHeight =
                el.nextElementSibling.scrollHeight +
                event.target.nextElementSibling.scrollHeight +
                'px'
            }, 450)
          }
        })
      }
    })
  }
})

// Class for ingredient list functionality
class IngredientList extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    this.ingredientItems = this.querySelectorAll('.product-details__ingredient')
    this.ingredientJson = document.querySelectorAll('[data-ingredients-json]')
    this.ingredientPopup = this.querySelector('.ingredient-popup')
    this.ingredientPopupContent = this.querySelector('.ingredient-popup__content')
    this.closeTriggers = this.querySelectorAll(
      '.ingredient-popup, .ingredient-popup__close'
    )

    if (!this.ingredientPopup) return

    this.ingredients = []
    this.loadIngredients()
    this.bindEvents()
  }

  loadIngredients() {
    this.ingredientJson.forEach((el) => {
      try {
        const data = JSON.parse(el.innerHTML)
        this.ingredients.push(...data)
      } catch (error) {
        console.warn('Error parsing ingredients JSON:', error)
      }
    })
  }

  bindEvents() {
    this.addEventListener('click', (event) => this.openPopup(event))
    this.closeTriggers.forEach((item) => {
      item.addEventListener('click', (e) => this.closePopup(e))
    })
  }

  openPopup(event) {
    const item = event.target
    const id = item.dataset.handle
    if (id === undefined) return

    item.classList.toggle('active')

    const currentIngredient = this.ingredients.filter((el) => el.id === id)

    if (currentIngredient.length > 0) {
      this.fillIngredientPopup(currentIngredient[0])
      this.ingredientPopup.classList.add('active')
    }
  }

  closePopup(e) {
    this.ingredientItems.forEach((ingredientItem) => {
      ingredientItem.classList.remove('active')
    })
    this.ingredientPopup.classList.remove('active')
  }

  fillIngredientPopup({
    abbreviation = '',
    title = '',
    text = '',
    link_title_one = '',
    date_one = '',
    link_one = '',
    link_title_two = '',
    date_two = '',
    link_two = '',
    link_title_three = '',
    date_three = '',
    link_three = ''
  }) {
    this.ingredientPopup.querySelector('.ingredient-popup__title').innerText = title
    this.ingredientPopup.querySelector('.ingredient-popup__abbr').innerText = abbreviation
    this.ingredientPopup.querySelector('.ingredient-popup__text').innerHTML = text

    const linkItemOne = this.ingredientPopup.querySelectorAll(
      '.ingredient-popup__link-title--one, .ingredient-popup__date--one, .ingredient-popup__link--one'
    )
    const linkItemTwo = this.ingredientPopup.querySelectorAll(
      '.ingredient-popup__link-title--two, .ingredient-popup__date--two, .ingredient-popup__link--two'
    )
    const linkItemThree = this.ingredientPopup.querySelectorAll(
      '.ingredient-popup__link-title--three, .ingredient-popup__date--three, .ingredient-popup__link--three'
    )
    const linkBlock = this.ingredientPopup.querySelectorAll('.ingredient-popup__links')

    link_title_one.trim() ? this.show(linkItemOne) : this.hide(linkItemOne)
    this.ingredientPopup.querySelector('.ingredient-popup__link-title--one').innerText = link_title_one
    this.ingredientPopup.querySelector('.ingredient-popup__date--one').innerText = date_one
    this.ingredientPopup.querySelector('.ingredient-popup__link--one').href = link_one

    link_title_two.trim() ? this.show(linkItemTwo) : this.hide(linkItemTwo)
    this.ingredientPopup.querySelector('.ingredient-popup__link-title--two').innerText = link_title_two
    this.ingredientPopup.querySelector('.ingredient-popup__date--two').innerText = date_two
    this.ingredientPopup.querySelector('.ingredient-popup__link--two').href = link_two

    link_title_three.trim() ? this.show(linkItemThree) : this.hide(linkItemThree)
    this.ingredientPopup.querySelector('.ingredient-popup__link-title--three').innerText = link_title_three
    this.ingredientPopup.querySelector('.ingredient-popup__date--three').innerText = date_three
    this.ingredientPopup.querySelector('.ingredient-popup__link--three').href = link_three

    link_title_one.trim() || link_title_two.trim() || link_title_three.trim()
      ? this.show(linkBlock)
      : this.hide(linkBlock)
  }

  show(elementArray) {
    elementArray.forEach((el) => {
      el.style.display = 'block'
    })
  }

  hide(elementArray) {
    elementArray.forEach((el) => {
      el.style.display = 'none'
    })
  }
}

customElements.define('ingredient-list', IngredientList)

// Scroll to ingredients functionality
function initScrollToIngredients(configs = []) {
  const defaultConfigs = [
    {
      triggerSelector: '[data-scroll-to-ingredients]',
      desktopScrollTargetSelector: '.product-details',
      desktopTabSelector: '.product-details__nav-item[data-tab="ingredients"]',
      desktopTabText: 'ingredients',
      desktopTabCandidatesSelector: '.product-details__nav-item, [data-tab]',
      mobileAccordionFinder: () => findAccordion("ingredient-list", ["ingredient"],["data-ingredients","data-tab-ingredients"]),
      onMobileAfterScroll: (accordion) => handleMobileAccordion?.(accordion),
      mobileAfterScrollDelay: 300,
      waitOptions: { tries: 20, interval: 100 }
    },
    {
      triggerSelector: '[data-scroll-to-results]',
      desktopScrollTargetSelector: '.product-details',
      desktopTabSelector: '.product-details__nav-item[data-tab="results"]',
      desktopTabText: 'results',
      desktopTabCandidatesSelector: '.product-details__nav-item, [data-tab]',
      mobileAccordionFinder: () => findAccordion(".before-after__wrap", ["results"],["data-results"]),
      onMobileAfterScroll: (accordion) => handleMobileAccordion?.(accordion),
      mobileAfterScrollDelay: 300,
      waitOptions: { tries: 20, interval: 100 }
    }
  ];

  const resolvedConfigs = configs.length ? configs : defaultConfigs;
  const mqMobile = window.matchMedia('(max-width: 990px)');

  resolvedConfigs.forEach((config) => {
    const {
      triggerSelector,
      desktopScrollTargetSelector,
      desktopTabSelector,
      desktopTabText,
      desktopTabCandidatesSelector,
      mobileAccordionFinder,
      onMobileAfterScroll,
      mobileAfterScrollDelay,
      waitOptions
    } = config;

    if (!triggerSelector) {
      console.warn('Scroll config skipped: triggerSelector is missing');
      return;
    }

    const scrollButtons = document.querySelectorAll(triggerSelector);
    if (!scrollButtons.length) {
      console.warn(`Scroll trigger not found for selector: ${triggerSelector}`);
      return;
    }

    scrollButtons.forEach((scrollButton) => {
      scrollButton.addEventListener('click', async (e) => {
        e.preventDefault();

        const desktopScrollTarget = desktopScrollTargetSelector
          ? document.querySelector(desktopScrollTargetSelector)
          : null;

        // MOBILE (accordion) path
        const mobileAccordion = mobileAccordionFinder?.();
        if (mqMobile.matches && mobileAccordion) {
          smoothScrollTo(mobileAccordion);
          if (onMobileAfterScroll) {
            setTimeout(() => {
              onMobileAfterScroll(mobileAccordion);
            }, mobileAfterScrollDelay ?? 300);
          }
          return;
        }

        // DESKTOP (tabs) path
        if (desktopScrollTarget) {
          smoothScrollTo(desktopScrollTarget);
        }

        const desktopTab = await waitForElement(() => {
          let el = desktopTabSelector ? document.querySelector(desktopTabSelector) : null;
          if (el) return el;

          const candidates = desktopTabCandidatesSelector
            ? document.querySelectorAll(desktopTabCandidatesSelector)
            : [];
          const expectedText = (desktopTabText || '').trim().toLowerCase();

          if (expectedText) {
            for (const c of candidates) {
              const text = c.textContent?.trim().toLowerCase();
              if (text === expectedText) return c;
            }
          }

          return null;
        }, waitOptions || { tries: 20, interval: 100 });

        if (desktopTab) {
          const clickable = desktopTab.matches('button, a') ? desktopTab : desktopTab.querySelector('button, a') || desktopTab;
          clickable.click();
        } else {
          console.warn(`Desktop tab not found for trigger: ${triggerSelector}`);
        }
      });
    });
  });
}

function smoothScrollTo(targetEl) {
  const sticky = document.querySelector('[data-sticky-header]');
  const headerH = sticky ? sticky.offsetHeight : 0;
  const top = targetEl.getBoundingClientRect().top + window.pageYOffset - headerH - 8;

  window.scrollTo({ top, behavior: 'smooth' });
}

function waitForElement(getterFn, { tries = 15, interval = 120 } = {}) {
  return new Promise((resolve) => {
    let attempts = 0;
    const tick = () => {
      const el = getterFn();
      if (el) return resolve(el);
      attempts += 1;
      if (attempts >= tries) return resolve(null);
      setTimeout(tick, interval);
    };
    tick();
  });
}

function findAccordion(selector, text, attribute) {
  const accordions = document.querySelectorAll(".product-details__mobile-accordion.js-accordion");

  const textList = Array.isArray(text) ? text : [text];
  const attrList = Array.isArray(attribute) ? attribute : [attribute];

  for (const accordion of accordions) {
    // Strategy 1: check if next sibling contains target selector
    const nextSibling = accordion.nextElementSibling;
    if (nextSibling && selector && nextSibling.querySelector(selector)) {
      return accordion;
    }

    // Strategy 2: check text content for target keyword(s)
    const accordionText = (accordion.textContent || "").toLowerCase();
    if (
      textList.some(
        (keyword) => keyword && accordionText.includes(String(keyword).toLowerCase()),
      )
    ) {
      return accordion;
    }

    // Strategy 3: check if accordion has target attribute(s)
    if (attrList.some((attr) => attr && accordion.hasAttribute(attr))) {
      return accordion;
    }
  }

  console.warn("Accordion not found among", accordions.length, "accordions");
  return null;
}

function handleMobileAccordion(accordion) {
  // Check if accordion is already open
  if (!accordion.classList.contains('js-active')) {
    // Trigger accordion click to open it
    accordion.click()
  }
}

// Initialize scroll functionality when DOM is ready
DOMready(initScrollToIngredients)
